import React from 'react';
export function TestimonialsSection() {
  return <section className="w-full bg-beige py-12 md:py-20 px-4" data-id="element-208">
      <div className="max-w-[680px] mx-auto" data-id="element-209">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray text-center mb-10" data-id="element-210">
          ⭐ Lo Que Dicen Mujeres Reales:
        </h2>

        <div className="space-y-5" data-id="element-211">
          {/* Testimonial 1 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border-l-4 border-pink-light" data-id="element-212">
            <div className="text-amber-400 text-sm mb-3" aria-label="5 estrellas" data-id="element-213">
              ⭐⭐⭐⭐⭐
            </div>
            <p className="font-body italic text-dark-gray mb-4 leading-relaxed" data-id="element-214">
              "Aprendí a tejer mi primera bikini en una semana. Las
              explicaciones son tan claras que ni necesité experiencia previa."
            </p>
            <p className="font-body font-bold text-sm text-dark-gray" data-id="element-215">
              — Micaela R. —{' '}
              <span className="text-medium-gray font-normal" data-id="element-216">
                Compradora Verificada ✅
              </span>
            </p>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border-l-4 border-pink-light" data-id="element-217">
            <div className="text-amber-400 text-sm mb-3" aria-label="5 estrellas" data-id="element-218">
              ⭐⭐⭐⭐⭐
            </div>
            <p className="font-body italic text-dark-gray mb-4 leading-relaxed" data-id="element-219">
              "Hice dos modelos diferentes y ya los vendí en Instagram. Este
              ebook se paga solo cien veces."
            </p>
            <p className="font-body font-bold text-sm text-dark-gray" data-id="element-220">
              — Sofía D. —{' '}
              <span className="text-medium-gray font-normal" data-id="element-221">
                Compradora Verificada ✅
              </span>
            </p>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border-l-4 border-pink-light" data-id="element-222">
            <div className="text-amber-400 text-sm mb-3" aria-label="5 estrellas" data-id="element-223">
              ⭐⭐⭐⭐⭐
            </div>
            <p className="font-body italic text-dark-gray mb-4 leading-relaxed" data-id="element-224">
              "Nunca había tejido ropa. Con las tablas de medidas y los pasos
              visuales, mi primera pieza me quedó perfecta."
            </p>
            <p className="font-body font-bold text-sm text-dark-gray" data-id="element-225">
              — Paula S. —{' '}
              <span className="text-medium-gray font-normal" data-id="element-226">
                Compradora Verificada ✅
              </span>
            </p>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border-l-4 border-pink-light" data-id="element-227">
            <div className="text-amber-400 text-sm mb-3" aria-label="5 estrellas" data-id="element-228">
              ⭐⭐⭐⭐⭐
            </div>
            <p className="font-body italic text-dark-gray mb-4 leading-relaxed" data-id="element-229">
              "Encontré una nueva pasión. Tejer bikinis es terapéutico Y
              rentable."
            </p>
            <p className="font-body font-bold text-sm text-dark-gray" data-id="element-230">
              — Valeria C. —{' '}
              <span className="text-medium-gray font-normal" data-id="element-231">
                Compradora Verificada ✅
              </span>
            </p>
          </div>

          {/* Testimonial 5 */}
          <div className="bg-white rounded-2xl shadow-md p-6 border-l-4 border-pink-light" data-id="element-232">
            <div className="text-amber-400 text-sm mb-3" aria-label="5 estrellas" data-id="element-233">
              ⭐⭐⭐⭐⭐
            </div>
            <p className="font-body italic text-dark-gray mb-4 leading-relaxed" data-id="element-234">
              "Los detalles de terminación hacen toda la diferencia. Mis piezas
              se ven profesionales."
            </p>
            <p className="font-body font-bold text-sm text-dark-gray" data-id="element-235">
              — Juliana G. —{' '}
              <span className="text-medium-gray font-normal" data-id="element-236">
                Compradora Verificada ✅
              </span>
            </p>
          </div>
        </div>

        <div className="text-center mt-10 font-body" data-id="element-237">
          <p className="font-bold text-dark-gray text-base md:text-lg" data-id="element-238">
            📊 +3.500 mujeres ya descargaron esta guía.
          </p>
          <p className="font-bold text-dark-gray text-base md:text-lg" data-id="element-239">
            Muchas de ellas hoy venden lo que tejen.
          </p>
        </div>
      </div>
    </section>;
}